/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';
import { RenameSchemaDefinitionCommand } from './RenameSchemaDefinitionCommand';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';

/**
 * @author eric.wittmann@gmail.com
 * @extends RenameSchemaDefinitionCommand
 * @class
 */
export class RenameSchemaDefinitionCommand_30 extends RenameSchemaDefinitionCommand {
    public constructor(oldName? : any, newName? : any) {
        if(((typeof oldName === 'string') || oldName === null) && ((typeof newName === 'string') || newName === null)) {
            let __args = arguments;
            super(oldName, newName);
        } else if(oldName === undefined && newName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand#_nameToReference(java.lang.String)
     * @param {string} name
     * @return {string}
     */
    _nameToReference(name : string) : string {
        return "#/components/schemas/" + name;
    }

    /**
     * @see RenameSchemaDefinitionCommand#_renameSchemaDefinition(Document, String, String)
     * @param {Document} document
     * @param {string} fromName
     * @param {string} toName
     * @return {boolean}
     */
    _renameSchemaDefinition(document : Document, fromName : string, toName : string) : boolean {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components) || this.isNullOrUndefined(doc30.components.schemas)) {
            return false;
        }
        if(ModelUtils.isDefined(doc30.components.getSchemaDefinition(toName))) {
            return false;
        }
        let schemaDef : Oas30SchemaDefinition = doc30.components.removeSchemaDefinition(fromName);
        schemaDef.rename(toName);
        doc30.components.addSchemaDefinition(toName, schemaDef);
        return true;
    }
}
RenameSchemaDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSchemaDefinitionCommand_30";
RenameSchemaDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




